import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const PlayStoreIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="-5 -2 30 25">
		<path
			fill="currentColor"
			d="M0.358294 0.898487C0.131342 1.13538 0 1.5042 0 1.98183V19.0187C0 19.4964 0.131342 19.8652 0.358294 20.1021L0.414309 20.1541L9.9888 10.611V10.3857L0.414309 0.842637L0.358294 0.898487Z"
		/>

		<path
			fill="currentColor"
			d="M14.3356 13.7936L11.1477 10.611V10.3857L14.3395 7.20306L14.411 7.24447L18.1909 9.389C19.2697 9.9976 19.2697 10.9991 18.1909 11.6115L14.411 13.7522L14.3356 13.7936Z"
		/>

		<path fill="currentColor" d="M13.8315 14.3448L10.5683 11.091L0.937739 20.6947C1.29603 21.0702 1.88032 21.1155 2.54476 20.7399L13.8315 14.3448Z" />
		<path fill="currentColor" d="M13.8315 6.65188L2.54476 0.256784C1.88032 -0.114923 1.29603 -0.0696644 0.937739 0.305894L10.5683 9.90576L13.8315 6.65188Z" />
	</SvgIcon>
)

export default PlayStoreIconAtom
